import * as Highcharts from 'highcharts';

export enum XAxisLabelTier {
  AllDays = 'allDays',
  Compact = 'compact',
  Letters = 'letters',
  Weekly = 'weekly',
}

export interface XAxisWeekCell {
  anchor: number;
  dayCount: number;
  weekStart: number;
  weekIndex: number;
  weekCount?: number;
}

export interface XAxisLabelPlan {
  tier: XAxisLabelTier;
  positions: number[];
  cells: Map<number, XAxisWeekCell>;
  weekTextStride: number;
}

export interface WeekendSpan {
  from: number;
  to: number;
}

export interface TieredLabelAxis extends Highcharts.Axis {
  labelTierPlan?: XAxisLabelPlan | null;
}

/** Compact charts (dashboard widgets) drop the weekday and use a shorter day row. */
export interface XAxisLabelOptions {
  showWeekday?: boolean;
  dayRowHeightPx?: number;
  /** Render dates in a single plot-wide row, independent of week boundaries. */
  independentDayLabels?: boolean;
  /** Space occupied by an overlaid unit at the start of the compact date row. */
  dayLabelInsetLeftPx?: number;
}

export interface WeekCellHtmlParams {
  axis: Highcharts.Axis;
  plan: XAxisLabelPlan;
  cell: XAxisWeekCell;
  dayBeforeMonth: boolean;
  labelOptions?: XAxisLabelOptions;
}

export type XAxisLabelTierTickPositioner = (
  this: Highcharts.Axis
) => Highcharts.AxisTickPositionsArray | undefined;
